import React from "react";
import ReactPlayer from "react-player";
import Hidden from "@material-ui/core/Hidden";
import useStyles from "./styled";

const VideoContent = (props) => {
  const {
    liveId,
    onClick,
    controls = true,
    width = "100%",
    height = "360px",
  } = props;
  const classes = useStyles();
  const handleClick = onClick;
  return (
    <div className={classes.root}>
      <Hidden mdUp>
        <ReactPlayer
          onClick={handleClick}
          className="player"
          controls={controls}
          width={width}
          height={height}
          url={`https://vimeo.com/${liveId}`}
        />
      </Hidden>
      <Hidden smDown>
        <ReactPlayer
          onClick={handleClick}
          className="player"
          controls={controls}
          width={width}
          height={height}
          url={`https://vimeo.com/${liveId}`}
        />
      </Hidden>
    </div>
  );
};

export default VideoContent;
